var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup457(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.09,
    height: 24,
    viewBox: "0 0 24.09 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(-402.048 -201.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M419.844,221.76c.287.277.567.56.859.83a.675.675,0,0,0,.971.027,18.88,18.88,0,0,0,3.668-4.349,6.9,6.9,0,0,0,.71-1.788v-.938a11.021,11.021,0,0,0-.347-1.28,4.84,4.84,0,0,0-5.868-2.847c-.044.013-.09.021-.172.04v-5.739c0-.649-.258-.9-.909-.9h-1.924v-.27c0-.649,0-1.3,0-1.946a.708.708,0,0,0-.8-.787H410.2a.721.721,0,0,0-.811.806c0,.64,0,1.281,0,1.921v.276h-.535c-.5,0-1,0-1.5,0a.73.73,0,0,0-.788.788c0,1.141,0,2.282,0,3.422v3.326h-.274c-1.133,0-2.266.017-3.4-.007a.785.785,0,0,0-.842.852q.022,5.859,0,11.719a.858.858,0,0,0,.522.9h22.964a.965.965,0,0,0,.516-.516v-.375a.843.843,0,0,0-.892-.528c-1.725.015-3.45.006-5.175.006h-.3v-2.769C419.747,221.678,419.8,221.716,419.844,221.76ZM415.4,204.8h-4.574v-1.562H415.4Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M420.64,221.615a19.518,19.518,0,0,1-3.1-3.856,3.75,3.75,0,0,1,.592-4.515,4.075,4.075,0,0,1,2.991-1.369,4.425,4.425,0,0,1,1.289.2,4.072,4.072,0,0,1,2.912,3.276,3.344,3.344,0,0,1-.41,2.3,15.4,15.4,0,0,1-2.387,3.177c-.184.2-.384.383-.589.57l-.784.739Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M421.124,212.625a3.694,3.694,0,0,1,1.073.168,3.33,3.33,0,0,1,2.394,2.709,2.619,2.619,0,0,1-.337,1.8,14.6,14.6,0,0,1-2.274,3.02c-.249.268-.529.506-.805.768a18.835,18.835,0,0,1-2.984-3.707,3.015,3.015,0,0,1,.488-3.623,3.305,3.305,0,0,1,2.445-1.134m0-1.5a4.808,4.808,0,0,0-3.535,1.6,4.537,4.537,0,0,0-.7,5.407,20.192,20.192,0,0,0,3.212,4.006l1.033,1.05,1.069-1.014c.082-.077.164-.152.245-.227.205-.188.416-.382.627-.608a16.126,16.126,0,0,0,2.5-3.336,4.057,4.057,0,0,0,.482-2.806,4.842,4.842,0,0,0-3.428-3.843,5.192,5.192,0,0,0-1.508-.232Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M410.857,207.821c.18,0,.359-.006.539,0a.716.716,0,1,1-.016,1.431c-.351,0-.7.006-1.054,0a.716.716,0,1,1-.008-1.43C410.5,207.816,410.677,207.821,410.857,207.821Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M410.849,221.3c-.18,0-.359,0-.539,0a.723.723,0,0,1-.731-.7.713.713,0,0,1,.708-.724c.374-.015.75-.014,1.125,0a.718.718,0,0,1,.718.737.73.73,0,0,1-.742.692C411.208,221.3,411.029,221.3,410.849,221.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M415.36,209.254c-.179,0-.359.005-.538,0a.716.716,0,0,1-.721-.708.706.706,0,0,1,.707-.72c.374-.013.75-.013,1.124,0a.714.714,0,0,1-.01,1.428C415.735,209.259,415.548,209.254,415.36,209.254Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M410.837,218.3c-.218-.009-.438,0-.653-.032a.7.7,0,0,1-.6-.719.708.708,0,0,1,.672-.685c.4-.015.8-.013,1.195,0a.715.715,0,0,1,.683.675.692.692,0,0,1-.615.73,5.658,5.658,0,0,1-.677.005Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M410.866,213.855c.188,0,.375,0,.562,0a.7.7,0,0,1,.7.7.7.7,0,0,1-.689.709q-.585.014-1.171,0a.7.7,0,0,1,.011-1.407C410.476,213.852,410.671,213.855,410.866,213.855Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M410.859,212.259c-.2,0-.39.005-.585,0a.715.715,0,0,1-.695-.687.693.693,0,0,1,.652-.721c.413-.018.828-.018,1.24,0a.687.687,0,0,1,.659.712.714.714,0,0,1-.709.7C411.234,212.263,411.047,212.259,410.859,212.259Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M415.372,212.259c-.188,0-.375,0-.562,0a.706.706,0,0,1-.709-.692.685.685,0,0,1,.673-.72c.4-.016.8-.016,1.193,0a.683.683,0,0,1,.673.72.7.7,0,0,1-.706.692C415.746,212.263,415.559,212.259,415.372,212.259Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M421.2,215.356c.367,0,.733,0,1.1,0a.719.719,0,0,1,.747.7.7.7,0,0,1-.715.71q-1.134.018-2.269,0a.7.7,0,0,1-.7-.723.727.727,0,0,1,.741-.69C420.468,215.354,420.835,215.356,421.2,215.356Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M405.016,219.048a.7.7,0,0,0,.6.718c.216.029.436.023.654.033v-.028c.091,0,.183,0,.275.006v-1.416c-.287,0-.574-.009-.861,0A.709.709,0,0,0,405.016,219.048Zm0,3.047a.723.723,0,0,0,.731.7c.179.006.359,0,.538,0,.088,0,.176,0,.264,0v-1.429c-.275-.005-.551-.011-.825,0A.713.713,0,0,0,405.016,222.1Zm1.287-6.741c-.2,0-.391,0-.586,0a.7.7,0,0,0-.01,1.407c.28.007.561,0,.842,0v-1.407Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup457);
export default __webpack_public_path__ + "static/media/Group 457.2229ca8a.svg";
export { ForwardRef as ReactComponent };